"use strict";var breakpoints={sm:"540px",md:"720px",lg:"960px","lg-max":{max:"960px"},xl:"1140px","2xl":"1320px"};module.exports=breakpoints;